module.exports = __webpack_public_path__ + "static/media/emojiIcon.85217a47.svg";